// extracted by mini-css-extract-plugin
module.exports = {"privacy-policy":"style_privacy-policy__MqhFn","email-link":"style_email-link__v59qd","link":"style_link___zl_8"};